<app-navbar></app-navbar>
<div class="bk">

  <div class="container">

    <div class="row">

      <div class="col-md-12 col-xs-12">

        <router-outlet></router-outlet>

      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>